export const tooltipStyled = (theme) => ({
  backgroundColor: theme.palette.colors.borderLine,
  borderRadius: '8px',
  padding: '12px',
  fontSize: '10px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onPrimaryBackground,
  boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.5)',
});
